import type { ComponentType, SVGProps } from "react"
import {
  FaFacebookF,
  FaGlobe,
  FaInstagram,
  FaLinkedinIn,
  FaTelegram,
  FaTiktok,
  FaWhatsapp,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6"

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>

const platforms: Record<string, { label: string; icon: IconComponent }> = {
  instagram: { label: "אינסטגרם", icon: FaInstagram },
  facebook: { label: "פייסבוק", icon: FaFacebookF },
  tiktok: { label: "טיקטוק", icon: FaTiktok },
  youtube: { label: "יוטיוב", icon: FaYoutube },
  linkedin: { label: "לינקדאין", icon: FaLinkedinIn },
  x: { label: "X", icon: FaXTwitter },
  whatsapp: { label: "וואטסאפ", icon: FaWhatsapp },
  telegram: { label: "טלגרם", icon: FaTelegram },
  website: { label: "אתר", icon: FaGlobe },
}

const platformColors: Record<string, string> = {
  instagram: "#e1306c",
  facebook: "#1877f2",
  tiktok: "#111111",
  youtube: "#ff0000",
  linkedin: "#0a66c2",
  x: "#111111",
  whatsapp: "#25d366",
  telegram: "#229ed9",
  website: "#0f766e",
}

export type SocialPlatformName = keyof typeof platforms

export const socialPlatformOptions = [
  { value: "instagram", label: "אינסטגרם" },
  { value: "facebook", label: "פייסבוק" },
  { value: "tiktok", label: "טיקטוק" },
  { value: "youtube", label: "יוטיוב" },
  { value: "linkedin", label: "לינקדאין" },
  { value: "x", label: "X" },
  { value: "whatsapp", label: "וואטסאפ" },
  { value: "telegram", label: "טלגרם" },
  { value: "website", label: "אתר" },
]

export function socialPlatformInputLabel(name?: string | null) {
  return name === "website" ? "כתובת אתר" : "שם משתמש"
}

export function socialPlatformInputPlaceholder(name?: string | null) {
  return name === "website" ? "example.com" : "username"
}

export function socialPlatformInputHint(name?: string | null) {
  return name === "website" ? "ניצור קישור מלא אוטומטית" : "ניצור את הקישור המלא אוטומטית"
}

export function getSocialPlatformIcon(name?: string | null) {
  if (!name) return null
  return platforms[name]?.icon ?? null
}

export function getSocialPlatformLabel(name?: string | null) {
  if (!name) return "קישור"
  return platforms[name]?.label ?? "קישור"
}

export function getSocialPlatformColor(name?: string | null) {
  if (!name) return "#0f766e"
  return platformColors[name] ?? "#0f766e"
}
